import { render, staticRenderFns } from "./SearchBarExpanding.vue?vue&type=template&id=2e94f9f6"
import script from "./SearchBarExpanding.vue?vue&type=script&lang=js"
export * from "./SearchBarExpanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports